<section class="page">
  <header class="page-header">
    <div>
      <h1>Support Tickets</h1>
      <p>Help &amp; Support requests from the mobile app</p>
    </div>
  </header>

  @if (error()) {
    <div class="alert alert-error">{{ error() }}</div>
  }

  <div class="panel filters">
    <div class="filter-grid">
      <label>
        <span>Status</span>
        <select [(ngModel)]="status">
          <option value="">Any</option>
          @for (s of statuses; track s) {
            <option [value]="s">{{ statusLabel(s) }}</option>
          }
        </select>
      </label>
      <label>
        <span>Topic</span>
        <select [(ngModel)]="topic">
          <option value="">Any</option>
          @for (t of topics; track t.key) {
            <option [value]="t.key">{{ t.label }}</option>
          }
        </select>
      </label>
      <label>
        <span>Search</span>
        <input
          type="text"
          [(ngModel)]="search"
          placeholder="email or message…"
          (keyup.enter)="applyFilters()"
        />
      </label>
    </div>
    <div class="filter-actions">
      <button class="btn btn-primary" type="button" (click)="applyFilters()" [disabled]="loading()">
        Search
      </button>
      <button class="btn btn-secondary" type="button" (click)="clearFilters()" [disabled]="loading()">
        Clear
      </button>
    </div>
  </div>

  <div class="panel">
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>User</th>
            <th>Topic</th>
            <th>Message</th>
            <th>Contact email</th>
            <th>Status</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          @if (loading()) {
            <tr>
              <td colspan="7" class="muted">Loading…</td>
            </tr>
          } @else if (!rows().length) {
            <tr>
              <td colspan="7" class="muted">No support tickets</td>
            </tr>
          } @else {
            @for (row of rows(); track row.id) {
              <tr class="clickable" [routerLink]="['/support-tickets', row.id]">
                <td>{{ row.id }}</td>
                <td>
                  <div>{{ userLabel(row) }}</div>
                  <div class="muted">#{{ row.user_id }}</div>
                </td>
                <td>{{ row.topic_label || row.topic }}</td>
                <td>{{ previewMessage(row.message) }}</td>
                <td>{{ row.email || '—' }}</td>
                <td>
                  <span class="badge" [attr.data-status]="row.status">{{ statusLabel(row.status) }}</span>
                </td>
                <td>{{ row.created_at ? (row.created_at | date: 'medium') : '—' }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="pager">
      <span class="muted">Page {{ page() }} of {{ totalPages() }} · {{ total() }} total</span>
      <div class="pager-actions">
        <button class="btn btn-secondary" type="button" (click)="prev()" [disabled]="page() <= 1 || loading()">
          Previous
        </button>
        <button
          class="btn btn-secondary"
          type="button"
          (click)="next()"
          [disabled]="page() >= totalPages() || loading()"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</section>
